
import { mapState } from 'vuex'
// import { throttle } from '~/utils/utils'
import wikiLoading from '~/components/common/wikiLoading.vue' // loading效果
import compareDetails from '~/components/compare/compareDetails'
import subNav from '~/components/common/subNav.vue'
import noData from '~/components/common/noData.vue'
import commonImg from '~/components/common/commonImg.vue'
import slideShow from '~/components/compare/slideShow'
import dealerModule from '@/components/dealer/head/dealerModule.vue'
import riskWarning from '@/components/dealer/head/riskWarning.vue'
import dealerTisk from '@/components/dealer/head/dealerTisk.vue'
import trader from '~/static/json/compareData.json'
import { debounce } from '~/utils/utils'
export default {
  name: 'DealerCompare',
  components: {
    'sub-nav': subNav,
    'no-data': noData,
    'common-img': commonImg,
    'slide-show': slideShow,
    'compare-details': compareDetails,
    'dealer-module': dealerModule,
    'risk-warning': riskWarning,
    'dealer-tisk': dealerTisk,
    'wiki-loading': wikiLoading
  },
  provide() {
    return {
      main: {},
      tips: this.tips // 风险提示
    }
  },
  async asyncData({ $api, app, store, route, res, $cookies, $serverlog, error }) {
    try {
      const compareRank = $api.home
        .invokev3data(
          {
            languageCode: store.state.LanguageCode,
            countryCode: store.state.CountryCode
          },
          {
            Routes: 'wikifx$traderexpandlist'
          }
        )
        .catch(() => {
          console.log('compare[asyncData],交易商对比rank接口错误')
        })

      let oldUrlNameList = (route && route.params && route.params.id && route.params.id.replace('.html', '').split('-vs-')) || []

      if ($cookies.get('compareAdCode') && oldUrlNameList.length <= 3) {
        oldUrlNameList = oldUrlNameList.filter((item) => item !== $cookies.get('compareAdCode'))
      }

      let excludeCodeList = []
      const excludeCode = []

      if (oldUrlNameList.length > 0) {
        excludeCodeList = await $api.compare.getUrlName({ codes: oldUrlNameList.toLocaleString() }).catch(() => {
          console.log('获取urlName错误,接口报错')
        })
      }

      if (excludeCodeList && excludeCodeList.length > 0)
        excludeCodeList.forEach((el) => {
          excludeCode.push(el?.TraderCode)
        })

      let hasAd = true
      let AdTrader = null
      let AdName = ''
      let AdCode = ''
      // console.log(excludeCode.toLocaleString(), 'toLocaleString()')
      if (oldUrlNameList.length < 3) {
        await $api.common
          .V3(
            {
              // 获取广告商的Code
              type: 860, // 固定参数
              excludeCode: excludeCode.toLocaleString()
            },
            {
              Routes: 'fxad$advertisementv2'
            }
          )
          .then(async (getAdCode) => {
            AdTrader = getAdCode.fxad?.advertisementv2?.data[0] // 广告obj
            AdCode = AdTrader?.code // 广告Code

            // console.log('AdCode::: ', AdTrader)
            AdName = null
            if (AdCode) {
              AdName = await $api.compare.getUrlName({ codes: AdCode }).catch(() => {
                console.log('获取AdName错误1')
              })
            }
            // url 去除.html,-vs- // 获取交易商urlName 和urlCodeList
            if (AdName && AdName[0]?.Name)
              $cookies.set('compareAdCode', AdName && AdName[0]?.Name, {
                path: '/',
                domain: store.state.cookieHost
              })
            hasAd = !oldUrlNameList.includes()
            if (AdName && AdName[0]?.Name) oldUrlNameList.push(AdName && AdName[0]?.Name)
          })
          .catch(() => {
            console.log('获取对比广告错误')
            res.statusCode = 404
            return {
              isShow404: true
            }
          })
      }
      const urlNameList = [...new Set(oldUrlNameList)]

      const rankList = []
      if (urlNameList.length === 0) {
        // 如果没有就干掉
        return Promise.all([compareRank]).then((result) => {
          const expandlist =
            result[0] && result[0].wikifx && result[0].wikifx.traderexpandlist && result[0].wikifx.traderexpandlist.data && result[0].wikifx.traderexpandlist.data.length > 0
              ? result[0].wikifx.traderexpandlist.data
              : []
          if (!expandlist || expandlist.length == 0) {
            console.log(404, '第一个')
            res.statusCode = 404
            return {
              isShow404: true
            }
          }
          console.log(expandlist, '对比排行榜', store.state.LanguageCode, store.state.CountryCode)
          expandlist &&
            expandlist.forEach((el) => {
              rankList.push({
                value: el.shortName,
                code: el.traderCode,
                ico: el.ico,
                logo: el.logo,
                name: el.localShortName
              })
            })
          return { rankList }
        })
      }

      const traderParams = trader
      // 3351410785 0361170645 0001378443 forex-com xm fxtm
      const codes = urlNameList.toLocaleString()
      let traderCodeList = []
      if (codes) {
        traderCodeList = await $api.compare.getUrlName({ codes }).catch(() => {
          console.log('获取urlName错误1')
        })
      }
      const urlCodeList = [] // 交易商 urlCodeList
      traderCodeList &&
        traderCodeList.forEach((el) => {
          urlCodeList.push(el.TraderCode)
        })
      if (urlNameList.length !== urlCodeList.length) {
        // console.log(urlNameList, urlCodeList)
        console.log(404, '第二个')
        res.statusCode = 404
        return {
          isShow404: true
        }
      }
      if (urlCodeList.length === 0) return
      const compareInit = $api.compare
        .compareInit({
          traderCodes: urlCodeList,
          ip: store.state.userIp,
          period: 2,
          isWeb: 1,
          platformType: 2,
          index: 1,
          size: 20
        })
        .catch(() => {
          console.log('compare,交易商对比init接口错误')
        })
      let atArrAll = []
      let atArr = []
      const atArr1 = []
      const atArr2 = []
      const atArr3 = []
      if (urlCodeList.length > 1) {
        const rankOne = traderParams.findIndex((item) => {
          return item.name == urlNameList[0]
        })

        const rankTwo = traderParams.findIndex((item) => {
          return item.name == urlNameList[1]
        })

        if (rankOne > rankTwo) {
          // console.log('rankOne > rankTwo')
        }
        const traderArr = traderParams.filter((item) => {
          return item.name != urlNameList[0] && item.name != urlNameList[1]
        })
        const mathIndex = rankTwo + 1
        atArrAll = traderArr.slice(mathIndex)
        if (urlCodeList.length == 3) {
          const rankThree = traderParams.findIndex((item) => {
            return item.name == urlNameList[2]
          })
          const traderArr = traderParams.filter((item) => {
            return item.name != urlNameList[0] && item.name != urlNameList[1] && item.name != urlNameList[2]
          })
          const mathIndex = rankThree + 1
          atArrAll = traderArr.slice(mathIndex)
        }
        atArrAll &&
          atArrAll.slice(0, 6).forEach((el) => {
            atArr1.push({
              code: el.code,
              name: el.name,
              urlName: urlNameList[0]
            })
            atArr2.push({
              code: el.code,
              name: el.name,
              urlName: urlNameList[1]
            })
            if (urlNameList[2]) {
              atArr3.push({
                code: el.code,
                name: el.name,
                urlName: urlNameList[2]
              })
            }
          })
      }
      atArr = [...atArr1, ...atArr2, ...atArr3]
      const elUrlNameList = []
      urlNameList &&
        urlNameList.forEach((el) => {
          elUrlNameList.push({
            urlName: el
          })
        })
      const tipsmodule = $api.dealer.tips().catch(() => {}) // 风险提示

      return Promise.all([compareInit, compareRank, tipsmodule]).then((result) => {
        if (!result[0]) {
          console.log('compare,交易商对比init接口错误---------error')
          res.statusCode = 404
          return {
            isShow404: true
          }
        }
        const list = [{}, {}, {}]
        const traderInfo = result[0].TraderInfoResponse || []
        const infoData = result[0].TradeBrokersContrastResponse || []
        const traderCount = result[0].TraderCountResponse?.items || []
        const exposedTraderList = result[0].ExposedTraderList || []
        const MultipleTrader = result[0].MultipleTrader || []
        const TraderArticles = result[0].TraderArticles || []
        const TraderIntros = result[0].TraderIntros || []
        // 排行榜
        const expandlist =
          result[1] && result[1].wikifx && result[1].wikifx.traderexpandlist && result[1].wikifx.traderexpandlist.data && result[1].wikifx.traderexpandlist.data.length > 0
            ? result[1].wikifx.traderexpandlist.data
            : []
        // console.log(expandlist, 9998)
        if (expandlist && expandlist.length > 0) {
          expandlist.forEach((el) => {
            rankList.push({
              value: el.shortName,
              code: el.traderCode || el.code,
              ico: el.ico,
              logo: el.logo,
              name: el.localShortName,
              hitsInfo: el.hitsInfo
            })
          })
        }
        const exposedTotal = []
        // 天眼曝光
        exposedTraderList.forEach((el) => {
          // console.log(el, 'el123')
          exposedTotal.push({ exposedTotal: el.count })
        })
        const traderlist = traderInfo.map((item, index) => {
          return {
            ...elUrlNameList[index],
            ...infoData[index],
            ...MultipleTrader[index],
            ...TraderArticles[index],
            ...TraderIntros[index],
            ...traderCount[index],
            ...exposedTotal[index],
            ...item
          }
        })
        //
        const dealerNameList = []
        traderlist &&
          traderlist.forEach((el, i) => {
            const emptyLlist = []
            el.accounts &&
              el.accounts.forEach((val) => {
                emptyLlist.push(val.accountName)
              })
            // shortName 放前面  localShortName放后面
            if (el.localshortname == el.shortName) {
              dealerNameList.push(el.shortName || el.localshortname)
            } else {
              dealerNameList.push(`${el.shortName || ''} ${el.localshortname || ''}`)
            }
            const licensesList = []
            el.basic &&
              el.basic.licenses &&
              el.basic.licenses.forEach((item) => {
                licensesList.push(item.shortName)
              })
            // console.log(el, '数据数据')
            list.splice(i, 1, {
              shortName: el.shortName,
              localshortname: el.localshortname,
              icon: el.icon, // ico
              urlName: el.urlName, // urlName
              content: el.content,
              summary: el.summary,
              TraderArticles: el.TraderArticles || null,
              MultipleTrader: el.MultipleTraderExposure || null,
              exposedTotal: el.exposedTotal || 0,
              surveyList: el.list || [],
              code: el.code || el.TraderCode,
              logo: el.logo,
              // 天眼评分
              score: ((el.rating && el.rating.score) * 1).toFixed(2) || '--',
              status: (el.rating && el.rating.status) || '--',
              isEPC: el?.rating.isEPC == 'true' ? '保障中' : '无保障',
              risk: (el.rating && el.rating.risk) || 0,
              webSite: el.rating.webSite || '--', // 网址
              // 基本信息
              established: el.basic.established || '--',
              licensesItems: licensesList.toString() || '--',
              existmt4: el.basic.existmt4.toString() == 'true' ? 1 : 0,
              existmt5: el.basic.existmt5.toString() == 'true' ? 1 : 0,
              existcurrency: el.basic.existcurrency.toString() == 'true' ? 1 : 0,
              methods: el.basic.methods || '--',
              // 交易环境
              Grade: el.Grade || '--',
              SpeedGrade: el.SpeedGrade || '--',
              AveSpeed: el.AveSpeed || '--',
              FastestSpeed: el.FastestSpeed || '--',
              FastestSpeed_Open: el.FastestSpeed_Open || '--',
              FastestSpeed_Close: el.FastestSpeed_Close || '--',
              SlowestSpeed: el.SlowestSpeed || '--',
              SlowestSpeed_Open: el.SlowestSpeed_Open || '--',
              SlowestSpeed_Close: el.SlowestSpeed_Close || '--',
              // 交易滑点
              SlipGrade: el.SlipGrade || '--',
              AveSlip_wh: el.AveSlip_wh || '--',
              AveSlip_xau: el.AveSlip_xau || '--',
              MaxSlip: el.MaxSlip || '--',
              MaxSlip_Positive: el.MaxSlip_Positive || '--',
              MaxSlip_Negative: el.MaxSlip_Negative || '--',
              // 交易成本
              CostGrade: el.CostGrade || '--',
              AveCost_wh: el.AveCost_wh ? 'EURUSD：' + el.AveCost_wh : '--',
              AveCost_xau: el.AveCost_xau ? 'XAUUSD：' + el.AveCost_xau : '--',
              // 隔夜成本
              SwapGrade: el.SwapGrade || '--',
              AveLongSwap_wh: el.AveLongSwap_wh || '--',
              AveShortSwap_wh: el.AveShortSwap_wh || '--',
              AveLongSwap_xau: el.AveLongSwap_xau || '--',
              AveShortSwap_xau: el.AveShortSwap_xau || '--',
              // 断线情况
              OffLineGrade: el.OffLineGrade || '--',
              AveReconnectNum: el.AveReconnectNum || '--',
              AveReconnectTime: el.AveReconnectTime || '--',
              // 账户信息
              accountName: (el.accounts && el.accounts[0] && el.accounts[0].accountName) || '--',
              allAccounts: el.accounts || [
                {
                  accountName: '--',
                  transactionType: '--',
                  enterCondition: '--',
                  maxLever: '--',
                  mainSpread: '--',
                  outStockRatio: '--',
                  spreadType: '--',
                  minCash: '--',
                  allowLock: '--',
                  allowScalping: '--',
                  allowEA: '--',
                  cryptocurrency: '--'
                }
              ], // 数组 所有账户
              allName: emptyLlist.toString() || '--',
              AdSlogan: hasAd && el.code == AdCode ? AdTrader.slogan || 'AD' : null,
              hitsInfo: hasAd && el.code == AdCode ? AdTrader.hitsInfo : null
            })
          })

        let TDKName = null
        let TDKList = null
        try {
          TDKName = JSON.parse(JSON.stringify(dealerNameList))
          TDKList = JSON.parse(JSON.stringify(urlNameList))
        } catch {}

        return {
          urlCodeList,
          list,
          urlNameList,
          rankList,
          traderInfo,
          infoData,
          traderCount,
          atArr,
          dealerNameList,
          AdTrader,
          ADobj: AdName,
          hasAd,
          TDKName,
          TDKList,
          tips: result?.[2] || {} // 风险提示
        }
      })
    } catch (err) {
      $serverlog(error(err).message)
    }
  },
  data() {
    return {
      hasAd: false,
      ADobj: null,
      surveyObj: {
        show: false,
        cover: '',
        name: ''
      },
      isSurveyCoverPopUpShow: false, // 实勘图片弹出框
      surveyCover: '',
      mobile: {
        // 只有在手机模式下才有的关闭默认的模块
        grade: true,
        env: true,
        aInfo: true
      },
      mobileSearchValue: '',
      AdTrader: null,
      methodsItemHeight: 60,
      autoSerarchValue: '', // 侧边栏新的搜索值
      isLastTrader: false, // 是否是最后一个交易商,唯一一个交易商隐藏删除Btn
      hiddenElement: false, // 隐藏相同的参数
      highlightELement: false, // 高亮不同的参数
      dealerNameList: [], // 交易商名称List
      scrolleds: 0, // 滚动的高度
      isShowMobileTabList: false,
      loading: false, // 触发loading
      autocompleteValue: ['', '', '', '', ''],
      scroll_new: true, // 滚动条
      isPinnedLeft: false, // 是否钉在左侧
      isPinnedLeftCode: '', // 被盯住的code
      pinnedLeftIndex: 0, // 被钉住的索引
      urlCodeList: [],
      urlNameList: [],
      rankList: [], // 排行默认
      navData: [
        // 导航数据
        { link: '/', text: '首页', type: 'a', full: true },
        { link: '/compare', text: '交易商对比', type: 'span' }
      ],
      tabList: [
        // tabs
        { name: this.$v('天眼评级'), link: 'first-floor', type: 0 },
        { name: this.$v('基本信息'), link: 'second-floor', type: 1 },
        { name: this.$v('交易环境'), link: 'third-floor', type: 2 },
        { name: this.$v('账户信息'), link: 'fourth-floor', type: 3 }
      ],
      isActived: 0, // tabList的选择,默认第一条
      isShow404: false, // 是否展示404
      dealerName: [], // 交易商名称
      tabIndex: 0, // 默认选择0
      list: [{}, {}, {}],
      traderInfo: [],
      infoData: [],
      traderCount: null,
      exposedTraderList: [],
      UrlName: null, // 被
      accountName: '',
      accountsIndex: [0, 0, 0], // 账户信息
      atArr: [], // 对比页面的数据
      selector: 'first-floor',
      isHidden: {
        // 隐藏相同的数据
        grade: {
          // 天眼评级
          score: true,
          status: true,
          isEPC: true,
          surveyList: true,
          risk: true,
          exposedTotal: true,
          webSite: true
        },
        bInfo: {
          // 基本信息
          established: true,
          licensesItems: true,
          existmt4: true,
          existmt5: true,
          existcurrency: true,
          methods: true
        },
        env: {
          Grade: true,
          SpeedGrade: true,
          AveSpeed: true,
          FastestSpeed: true,
          FastestSpeed_Open: true,
          FastestSpeed_Close: true,
          SlowestSpeed: true,
          SlowestSpeed_Open: true,
          SlowestSpeed_Close: true,
          SlipGrade: true,
          AveSlip: {
            // AveSlip_wh  AveSlip_xau
            wh: true,
            xau: true
          },
          MaxSlip: true,
          MaxSlip_Positive: true,
          MaxSlip_Negative: true,
          CostGrade: true, // 交易成本评级
          // AveCost_wh  AveCost_xau
          AveCost: {
            wh: true,
            xau: true
          },
          SwapGrade: true,
          // AveLongSwap_wh AveShortSwap_wh AveLongSwap_xau AveShortSwap_xau
          AveLongSwap: {
            wh: true,
            xau: true
          },
          AveShortSwap: {
            wh: true,
            xau: true
          },
          OffLineGrade: true,
          AveReconnectNum: true,
          AveReconnectTime: true
        },
        aInfo: {
          allName: true,
          accountName: true,
          transactionType: true,
          enterCondition: true,
          maxLever: true,
          mainSpread: true,
          outStockRatio: true,
          spreadType: true,
          minCash: true,
          cryptocurrency: true,
          allowLock: true,
          allowScalping: true,
          allowEA: true
        },
        TDKName: [],
        TDKList: []
      },
      companyWebsite: '', // 交易商官网链接
      returnWebsite: '', // 回调网址
      tips: {}, // 风险提示
      moduleShow: false, // 是否显示自定义弹框
      modelShow: false, // 是否显示弹框蒙层
      tipsType: '', // 弹框提示类型
      headshow: false
    }
  },
  head() {
    const IS_EN_CN = ['zh-cn', 'en'].includes(this.LanguageCode)
    const dealerNames = this.dealerNameList
    let title
    let content

    if (IS_EN_CN) {
      if (dealerNames.length === 3) {
        title = this.$t('62873')
          .replace('{0}', dealerNames[0] || '')
          .replace('{1}', dealerNames[1] || '')
          .replace('{2}', dealerNames[2] || '')

        content = this.$t('62872')
          .replace('{0}', dealerNames[0] || '')
          .replace('{1}', dealerNames[1] || '')
          .replace('{2}', dealerNames[2] || '')
      } else if (dealerNames.length === 2) {
        title = this.$t('62873')
          .replace('{0}', dealerNames[0] || '')
          .replace('{1}、', dealerNames[1] || '')
          .replace('{1}, and', dealerNames[1] || '')
          .replace('{2}', '')

        content = this.$t('62872')
          .replace('{0}', dealerNames[0] || '')
          .replace('{1}和', dealerNames[1] || '')
          .replace('{1}, and', dealerNames[1] || '')
          .replace('{2}', '')
      } else {
        title = this.$t('33636')
        content = this.$t('33637')
      }
    } else {
      title = this.$t('33636')
      content = this.$t('33637')
    }

    return {
      title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: this.googlenav(this.navData)
        }
      ]
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile',
      LanguageCode: 'LanguageCode',
      fatherDomain: 'fatherDomain'
    }),
    // 导航栏
    setTabList() {
      let tab = this.tabList
      // TraderArticles=>资讯
      if (this.TraderArticles.length > 0 || this.TraderArticles1.length > 0 || this.TraderArticles2.length > 0) {
        tab = [
          // tabs
          { name: this.$v('天眼评级'), link: 'first-floor', type: 0 },
          { name: this.$v('基本信息'), link: 'second-floor', type: 1 },
          { name: this.$v('交易环境'), link: 'third-floor', type: 2 },
          { name: this.$v('账户信息'), link: 'fourth-floor', type: 3 },
          { name: this.$v('相关资讯'), link: 'five-floor', type: 4 }
        ]
      }
      // MultipleTrader =>曝光
      if (this.MultipleTrader.length > 0 || this.MultipleTrader1.length > 0 || this.MultipleTrader2.length > 0) {
        tab = [
          // tabs
          { name: this.$v('天眼评级'), link: 'first-floor', type: 0 },
          { name: this.$v('基本信息'), link: 'second-floor', type: 1 },
          { name: this.$v('交易环境'), link: 'third-floor', type: 2 },
          { name: this.$v('账户信息'), link: 'fourth-floor', type: 3 },
          { name: this.$v('相关曝光'), link: 'five-floor', type: 5 }
        ]
      }
      if (
        (this.TraderArticles.length > 0 || this.TraderArticles1.length > 0 || this.TraderArticles2.length > 0) &&
        (this.MultipleTrader.length > 0 || this.MultipleTrader1.length > 0 || this.MultipleTrader2.length > 0)
      ) {
        tab = [
          // tabs
          { name: this.$v('天眼评级'), link: 'first-floor', type: 0 },
          { name: this.$v('基本信息'), link: 'second-floor', type: 1 },
          { name: this.$v('交易环境'), link: 'third-floor', type: 2 },
          { name: this.$v('账户信息'), link: 'fourth-floor', type: 3 },
          { name: this.$v('相关资讯'), link: 'five-floor', type: 4 },
          { name: this.$v('相关曝光'), link: 'six-floor', type: 5 }
        ]
      }
      return tab
    },

    TraderArticles() {
      return (this.list && this.list[0] && this.list[0].TraderArticles) || []
    },
    TraderArticles1() {
      return (this.list && this.list[1] && this.list[1].TraderArticles) || []
    },
    TraderArticles2() {
      return (this.list && this.list[2] && this.list[2].TraderArticles) || []
    },
    MultipleTrader() {
      return (this.list && this.list[0] && this.list[0].MultipleTrader) || []
    },
    MultipleTrader1() {
      return (this.list && this.list[1] && this.list[1].MultipleTrader) || []
    },
    MultipleTrader2() {
      return (this.list && this.list[2] && this.list[2].MultipleTrader) || []
    },
    totalDealer() {
      // const NumArr = []
      // this.list.forEach((el) => { if (el.shortName) NumArr.push(el.shortName) })
      const span = `<span>&nbsp;<span style="color:#DE7032">${this.urlCodeList.length}</span>&nbsp;</span>`
      const mibileSpan = `<span><span style="color:#DE7032">${this.urlCodeList.length}</span></span>` // H5样式
      return (this.isMobile ? this.$v('共 {0} 条交易商') : this.$v('共 {0} 条交易商')).replace('{0}', this.isMobile ? mibileSpan : span)
    },
    isLongLanguage() {
      const code = this.$store.state.LanguageCode
      if (code == 'zh-cn' || code == 'zh') return false
      else return true
    },

    // isLastTrader () { // 是否是最后一个交易商,唯一一个交易商隐藏删除Btn
    //   const NumArr = []
    //   this.list.forEach((el) => { if (el.shortName) NumArr.push(el.shortName) })
    //   if (NumArr.length < 2) {
    //     return true
    //   } else {
    //     return false
    //   }
    // }
    aInfoAccountList() {
      // 交易环境的list
      let arr = []
      if (this.urlCodeList.length < 2) return arr

      if (this.list && this.list[2].code) {
        arr = [this.list[0].allAccounts[this.accountsIndex[0]] || {}, this.list[1].allAccounts[this.accountsIndex[1]] || {}, this.list[2].allAccounts[this.accountsIndex[2]] || {}]
      } else {
        arr = [this.list[0].allAccounts[this.accountsIndex[0]] || {}, this.list[1].allAccounts[this.accountsIndex[1]] || {}]
      }
      return arr
    },

    isOverflowAuto() {
      return this.urlCodeList.length == 3 && this.isMobile
    }
  },
  watch: {
    list: {
      // 监听实际值隐藏和现实iconX
      handler(v) {
        const arr = []
        v.forEach((el) => {
          if (el.code) arr.push(el.code)
        })
        if (arr.length == 0) return

        if (arr.length < 2) {
          this.isLastTrader = false
          if (this.hiddenElement) {
            this.changeDom(false)
            this.hiddenElement = false
          }
        } else {
          this.isLastTrader = true
        }

        if (v.length > 3) this.list.slice(0, 3)
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    if (this.isMobile) {
      this.mobile.grade = false
      this.mobile.env = false
      this.mobile.aInfo = false
    }
  },
  mounted() {
    console.log()
    // this.$message.info(this.hasAd ? `有广告${this.ADobj[0].TraderCode}--${this.ADobj[0].Name},国家:${this.$store.state.CountryCode}` : '无广告')
    const container = document.getElementById('details-box')
    const newDiv = document.getElementById('newD')
    if (!container) return
    if (this.AdTrader && this.urlCodeList.length < 4) this.addUrlName('any', this.AdTrader.code, true)
    window.addEventListener('scroll', debounce(this.onScrolls, 100), {
      passive: true
    })

    if (!this.isMobile) {
      newDiv.getElementsByClassName('dealer-info-container')[0].addEventListener(
        'scroll',
        function () {
          container.getElementsByClassName('dealer-info-container')[0].scrollLeft = newDiv.getElementsByClassName('dealer-info-container')[0].scrollLeft
        },
        { passive: true }
      )
      container.parentNode.insertBefore(newDiv, container.nextSibling)
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScrolls)
  },
  methods: {
    adfn(item) {
      console.log(item, 887)
      this.adcountfn(item.hitsInfo)
    },
    tdkTitle() {
      if (this.TDKName?.length == 0 || this.TDKList?.lenght == 0) return ''
      const name = this.TDKName && this.TDKName[0]
      const name1 = this.TDKName && this.TDKName[1]
      const name2 = this.TDKName && this.TDKName[2]
      if (this.TDKList && this.TDKList[2]) {
        return this.$t('22385').replace('{1}', name).replace('{2}', name1).replace('{3}', name2)
      }
      if (this.TDKList && this.TDKList[1]) {
        return this.$t('22385')
          .replace('{1}', name)
          .replace('{2}', name1)
          .replace('vs {3}', '')
          .replace('กับ {3}', '')
          .replace('và {3}', '')
          .replace('と{3}', '')
          .replace('и {3}', '')
          .replace('{3} مقارنة', '')
          .replace('{3}', name2)
      } else {
        return ''
      }
    },
    tdkContent() {
      if (this.TDKName?.length == 0 || this.TDKList?.lenght == 0) return ''
      const name = this.TDKName && this.TDKName[0]
      const name1 = this.TDKName && this.TDKName[1]
      const name2 = this.TDKName && this.TDKName[2]
      if (this.TDKList && this.TDKList[2]) {
        return this.$t('22386').replace('{1}', name).replace('{2}', name1).replace('{3}', name2)
      }
      if (this.TDKList && this.TDKList[1]) {
        return this.$t('22386')
          .replace('{1}', name)
          .replace('{2}', name1)
          .replace('vs {3}', '')
          .replace('กับ {3}', '')
          .replace('và {3}', '')
          .replace('と{3}', '')
          .replace('и {3}', '')
          .replace('مقابل {3}', '')
          .replace('{3}', name2)
      } else {
        return ''
      }
    },
    spliceStr(str) {
      if (!str) return
      const index = str?.indexOf('?') // 找到第一个?的位置
      if (index != -1) return str.substring(0, index)
      else return str
    },
    openBottomPopUp(item, name) {
      if (this.isMobile) {
        this.surveyObj.cover = item.cover
        this.surveyObj.name = name
        this.surveyObj.show = true
      } else this.jumpLinkSurveyPage(item) // Pc跳转实勘详情
    },
    openModule(v) {
      // 打开手机模块 grade
      if (!this.isMobile) return
      if (v == 'grade') this.mobile.grade = !this.mobile.grade
      if (v == 'env') this.mobile.env = !this.mobile.env
      if (v == 'aInfo') this.mobile.aInfo = !this.mobile.aInfo
    },
    jumpLinkSearchPage() {
      if (this.urlCodeList?.length == 3) return this.$toast(this.$v('最多支持3个交易商对比！'))
      if (this.urlNameList.includes(this.$cookies.get('compareAdCode'))) {
        this.urlCodeList.pop()
        this.urlNameList.pop()
      }
      const url = `/${this.LanguageCode}/compare/search?code=${this.urlCodeList}&name=${this.urlNameList}`
      setTimeout(() => {
        window.open(url)
      }, 300)
    },
    jumpLinkSurveyPage(item) {
      // 跳转实勘详情
      // console.log(item)
      if (item.sids?.split(',')[0]) {
        if (this.isMobile) window.open(`${this.getwwwDomain(this.$store.state)}/${this.$store.state.LanguageCode}/dealer/${item.code}.html`)
        else window.open(`${this.getwwwDomain(this.$store.state)}/${this.$store.state.LanguageCode}/survey/${item.sids?.split(',')[0]}.html`)
      }
    },
    getMaxValue(arr) {
      const max = arr.sort(function (a, b) {
        return b - a
      })[0]
      return max
    },

    changeDom(v) {
      // 隐藏或者打开Dom
      if (!v) {
        this.isHidden.grade.score = true
        this.isHidden.grade.status = true
        this.isHidden.grade.status = true
        this.isHidden.grade.risk = true
        this.isHidden.grade.exposedTotal = true
        this.isHidden.grade.isEPC = true
        this.isHidden.grade.webSite = true

        this.isHidden.bInfo.established = true
        this.isHidden.bInfo.licensesItems = true
        this.isHidden.bInfo.existmt4 = true
        this.isHidden.bInfo.existmt5 = true
        this.isHidden.bInfo.existcurrency = true
        this.isHidden.bInfo.methods = true

        this.isHidden.env.Grade = true
        this.isHidden.env.SpeedGrade = true
        this.isHidden.env.AveSpeed = true
        this.isHidden.env.FastestSpeed = true
        this.isHidden.env.FastestSpeed_Open = true
        this.isHidden.env.FastestSpeed_Close = true
        this.isHidden.env.SlowestSpeed = true
        this.isHidden.env.SlowestSpeed_Open = true
        this.isHidden.env.SlowestSpeed_Close = true
        this.isHidden.env.SlipGrade = true
        // AveSlip_wh  AveSlip_xau
        this.isHidden.env.AveSlip.wh = true
        this.isHidden.env.AveSlip.xau = true
        this.isHidden.env.MaxSlip = true
        this.isHidden.env.MaxSlip_Positive = true
        this.isHidden.env.MaxSlip_Negative = true

        this.isHidden.env.CostGrade = true
        // AveCost_wh  AveCost_xau
        this.isHidden.env.AveCost.wh = true
        this.isHidden.env.AveCost.xau = true
        this.isHidden.env.SwapGrade = true
        // AveLongSwap_wh AveShortSwap_wh AveLongSwap_xau AveShortSwap_xau
        this.isHidden.env.AveLongSwap.wh = true
        this.isHidden.env.AveShortSwap.wh = true
        this.isHidden.env.AveLongSwap.xau = true
        this.isHidden.env.AveShortSwap.xau = true

        this.isHidden.env.OffLineGrade = true
        this.isHidden.env.AveReconnectNum = true
        this.isHidden.env.AveReconnectTime = true

        if (!this.hiddenElement) {
          document.getElementById('envSpeedBox').style.display = 'flex'
          document.getElementById('envSlipBox').style.display = 'flex'
          document.getElementById('envAveCostBox').style.display = 'flex'
          document.getElementById('envSwapGradeBox').style.display = 'flex'
          document.getElementById('envOffLineBox').style.display = 'flex'
        }

        this.isHidden.aInfo.allName = true
        this.isHidden.aInfo.accountName = true
        // allAccounts .accountName
        this.isHidden.aInfo.transactionType = true
        this.isHidden.aInfo.enterCondition = true
        this.isHidden.aInfo.maxLever = true
        this.isHidden.aInfo.mainSpread = true
        this.isHidden.aInfo.outStockRatio = true
        this.isHidden.aInfo.spreadType = true
        this.isHidden.aInfo.minCash = true
        this.isHidden.aInfo.cryptocurrency = true
        this.isHidden.aInfo.allowLock = true
        this.isHidden.aInfo.allowScalping = true
        this.isHidden.aInfo.allowE = true
      } else {
        /* 天眼评级 */
        const score = this.isSameFun(this.list, 'score')
        this.isHidden.grade.score = score
        const status = this.isSameFun(this.list, 'status')
        this.isHidden.grade.status = status
        const isEPC = this.isSameFun(this.list, 'isEPC')
        this.isHidden.grade.isEPC = isEPC
        const risk = this.isSameFun(this.list, 'risk')
        this.isHidden.grade.risk = risk
        const exposedTotal = this.isSameFun(this.list, 'exposedTotal')
        this.isHidden.grade.exposedTotal = exposedTotal
        const webSite = this.isSameFun(this.list, 'webSite')
        this.isHidden.grade.webSite = webSite
        /* 基本信息 */
        const established = this.isSameFun(this.list, 'established')
        this.isHidden.bInfo.established = established
        const licensesItems = this.isSameFun(this.list, 'licensesItems')
        this.isHidden.bInfo.licensesItems = licensesItems
        const existmt4 = this.isSameFun(this.list, 'existmt4')
        this.isHidden.bInfo.existmt4 = existmt4
        const existmt5 = this.isSameFun(this.list, 'existmt5')
        this.isHidden.bInfo.existmt5 = existmt5
        const existcurrency = this.isSameFun(this.list, 'existcurrency')
        this.isHidden.bInfo.existcurrency = existcurrency
        const methods = this.isSameFun(this.list, 'methods')
        this.isHidden.bInfo.methods = methods
        /** 交易环境 */

        const Grade = this.isSameFun(this.list, 'Grade')
        this.isHidden.env.Grade = Grade
        const SpeedGrade = this.isSameFun(this.list, 'SpeedGrade')
        this.isHidden.env.SpeedGrade = SpeedGrade
        const AveSpeed = this.isSameFun(this.list, 'AveSpeed')
        this.isHidden.env.AveSpeed = AveSpeed
        const FastestSpeed = this.isSameFun(this.list, 'FastestSpeed')
        this.isHidden.env.FastestSpeed = FastestSpeed
        const FastestSpeedOpen = this.isSameFun(this.list, 'FastestSpeed_Open')
        this.isHidden.env.FastestSpeed_Open = FastestSpeedOpen
        const FastestSpeedClose = this.isSameFun(this.list, 'FastestSpeed_Close')
        this.isHidden.env.FastestSpeed_Close = FastestSpeedClose
        const SlowestSpeed = this.isSameFun(this.list, 'SlowestSpeed')
        this.isHidden.env.SlowestSpeed = SlowestSpeed
        const SlowestSpeedOpen = this.isSameFun(this.list, 'SlowestSpeed_Open')
        this.isHidden.env.SlowestSpeed_Open = SlowestSpeedOpen
        const SlowestSpeedClose = this.isSameFun(this.list, 'SlowestSpeed_Close')
        this.isHidden.env.SlowestSpeed_Close = SlowestSpeedClose
        const SlipGrade = this.isSameFun(this.list, 'SlipGrade')
        this.isHidden.env.SlipGrade = SlipGrade

        // AveSlip_wh  AveSlip_xau
        const AveSlipwh = this.isSameFun(this.list, 'AveSlip_wh')
        this.isHidden.env.AveSlip.wh = AveSlipwh

        const AveSlipxau = this.isSameFun(this.list, 'AveSlip_xau')
        this.isHidden.env.AveSlip.xau = AveSlipxau

        const MaxSlip = this.isSameFun(this.list, 'MaxSlip')
        this.isHidden.env.MaxSlip = MaxSlip
        const MaxSlipPositive = this.isSameFun(this.list, 'GraMaxSlip_Positivede')
        this.isHidden.env.MaxSlip_Positive = MaxSlipPositive
        const MaxSlipNegative = this.isSameFun(this.list, 'MaxSlip_Negative')
        this.isHidden.env.MaxSlip_Negative = MaxSlipNegative
        const CostGrade = this.isSameFun(this.list, 'CostGrade')
        this.isHidden.env.CostGrade = CostGrade
        // AveCost_wh  AveCost_xau
        const AveCostwh = this.isSameFun(this.list, 'AveCost_wh')
        this.isHidden.env.AveCost.wh = AveCostwh
        const AveCostxau = this.isSameFun(this.list, 'AveCost_xau')
        this.isHidden.env.AveCost.xau = AveCostxau

        const SwapGrade = this.isSameFun(this.list, 'SwapGrade')
        this.isHidden.env.SwapGrade = SwapGrade
        // AveLongSwap_wh AveShortSwap_wh AveLongSwap_xau AveShortSwap_xau

        const AveLongSwapwh = this.isSameFun(this.list, 'AveLongSwap_wh')
        this.isHidden.env.AveLongSwap.wh = AveLongSwapwh
        const AveShortSwapwh = this.isSameFun(this.list, 'AveShortSwap_wh')
        this.isHidden.env.AveShortSwap.wh = AveShortSwapwh
        const AveLongSwapxau = this.isSameFun(this.list, 'AveLongSwap_xau')
        this.isHidden.env.AveLongSwap.xau = AveLongSwapxau
        const AveShortSwapxau = this.isSameFun(this.list, 'AveShortSwap_xau')
        this.isHidden.env.AveShortSwap.xau = AveShortSwapxau
        // 断线情况
        const OffLineGrade = this.isSameFun(this.list, 'OffLineGrade')
        this.isHidden.env.OffLineGrade = OffLineGrade
        const AveReconnectNum = this.isSameFun(this.list, 'AveReconnectNum')
        this.isHidden.env.AveReconnectNum = AveReconnectNum
        const AveReconnectTime = this.isSameFun(this.list, 'AveReconnectTime')
        this.isHidden.env.AveReconnectTime = AveReconnectTime
        // 账户信息
        const allName = this.isSameFun(this.list, 'allName')
        this.isHidden.aInfo.allName = allName

        // const accountName = this.isSameFun(this.aInfoAccountList)
        const accountName = this.isSameFun(this.aInfoAccountList, 'accountName')
        this.isHidden.aInfo.accountName = accountName

        const transactionType = this.isSameFun(this.aInfoAccountList, 'transactionType')
        this.isHidden.aInfo.transactionType = transactionType
        const enterCondition = this.isSameFun(this.aInfoAccountList, 'enterCondition')
        this.isHidden.aInfo.enterCondition = enterCondition
        const maxLever = this.isSameFun(this.aInfoAccountList, 'maxLever')
        this.isHidden.aInfo.maxLever = maxLever
        const mainSpread = this.isSameFun(this.aInfoAccountList, 'mainSpread')
        this.isHidden.aInfo.mainSpread = mainSpread
        const outStockRatio = this.isSameFun(this.aInfoAccountList, 'outStockRatio')
        this.isHidden.aInfo.outStockRatio = outStockRatio
        const spreadType = this.isSameFun(this.aInfoAccountList, 'spreadType')
        this.isHidden.aInfo.spreadType = spreadType
        const minCash = this.isSameFun(this.aInfoAccountList, 'minCash')
        this.isHidden.aInfo.minCash = minCash
        const cryptocurrency = this.isSameFun(this.aInfoAccountList, 'cryptocurrency')
        this.isHidden.aInfo.cryptocurrency = cryptocurrency
        const allowLock = this.isSameFun(this.aInfoAccountList, 'allowLock')
        this.isHidden.aInfo.allowLock = allowLock
        const allowScalping = this.isSameFun(this.aInfoAccountList, 'allowScalping')
        this.isHidden.aInfo.allowScalping = allowScalping
        const allowEA = this.isSameFun(this.aInfoAccountList, 'allowEA')
        this.isHidden.aInfo.allowEA = allowEA
      }
    },
    hiddenElementFun(v) {
      // 隐藏相同的
      if (this.urlCodeList.length < 2) {
        this.isLastTrader = true
        this.changeDom(false)
        return
      }
      if (process.client && this.hiddenElement && v) {
        this.loading = true
        if (this.isMobile) {
          this.mobile.env = true
          this.mobile.aInfo = true
          this.mobile.grade = true
        }
      }
      this.changeDom(v)
      if (process.client && this.hiddenElement && v) {
        setTimeout(() => {
          const envSpeedHeight = document.getElementById('envSpeed').offsetHeight
          document.getElementById('envSpeedType').style.height = envSpeedHeight + 'px'
          if (envSpeedHeight == 0) document.getElementById('envSpeedBox').style.display = 'none'

          const envSlipHeight = document.getElementById('envSlip').offsetHeight
          document.getElementById('envSlipType').style.height = envSlipHeight + 'px'
          if (envSlipHeight == 0) document.getElementById('envSlipBox').style.display = 'none'

          const envAveCostHeight = document.getElementById('envAveCost').offsetHeight
          document.getElementById('envAveCostType').style.height = envAveCostHeight + 'px'
          if (envAveCostHeight == 0) document.getElementById('envAveCostBox').style.display = 'none'

          const envSwapGradeHeight = document.getElementById('envSwapGrade').offsetHeight
          document.getElementById('envSwapGradeType').style.height = envSwapGradeHeight + 'px'
          if (envSwapGradeHeight == 0) document.getElementById('envSwapGradeBox').style.display = 'none'

          const envOffLineHeight = document.getElementById('envOffLine').offsetHeight
          document.getElementById('envOffLineType').style.height = envOffLineHeight + 'px'
          if (envOffLineHeight == 0) document.getElementById('envOffLineBox').style.display = 'none'

          this.loading = false
        }, 1000)
      }
    },

    isSameFun(arr, key) {
      if (arr.length > 3) arr = arr.slice(0, 3)
      if (!arr[2]?.code) arr = arr.slice(0, 2)
      // 获取数组中第一个对象的key的值
      const firstValue = arr[0][key] == '0.00' || arr[0][key] == '0.0' || arr[0][key] == '0' || !arr[0][key] ? '--' : arr[0][key]

      // 遍历数组，检查每个对象的key的值是否与第一个值相同
      for (let i = 1; i < arr.length; i++) {
        let newKey = arr[i][key]
        if (newKey == '0.00' || newKey == '0.0' || newKey == '0' || !newKey) newKey = '--'
        if (newKey != firstValue) {
          return true // 如果有不相同的值，返回false
        }
      }
      return false // 如果所有值都相同，返回true
    },

    // getshortName (n1, n2) {
    //   return getshortName(n1, n2)
    // },
    getAtArr() {
      const traderParams = trader
      const atArr1 = []
      const atArr2 = []
      const atArr3 = []
      if (this.urlCodeList.length > 1) {
        const rankOne = traderParams.findIndex((item) => {
          return item.name == this.urlNameList[0]
        })

        const rankTwo = traderParams.findIndex((item) => {
          return item.name == this.urlNameList[1]
        })

        if (rankOne > rankTwo) {
          // console.log('rankOne >  rankTwo')
        }
        const traderArr = traderParams.filter((item) => {
          return item.name != this.urlNameList[0] && item.name != this.urlNameList[1]
        })
        const mathIndex = rankTwo + 1
        this.atArr = traderArr.slice(mathIndex)
        if (this.urlCodeList.length == 3) {
          const rankThree = traderParams.findIndex((item) => {
            return item.name == this.urlNameList[2]
          })
          const traderArr = traderParams.filter((item) => {
            return item.name != this.urlNameList[0] && item.name != this.urlNameList[1] && item.name != this.urlNameList[2]
          })
          const mathIndex = rankThree + 1
          this.atArr = traderArr.slice(mathIndex)
        }
        this.atArr.slice(0, 6).forEach((el) => {
          atArr1.push({
            code: el.code,
            name: el.name,
            urlName: this.urlNameList[0]
          })
          atArr2.push({
            code: el.code,
            name: el.name,
            urlName: this.urlNameList[1]
          })
          if (this.urlNameList[2]) {
            atArr3.push({
              code: el.code,
              name: el.name,
              urlName: this.urlNameList[2]
            })
          }
        })
      }
      this.atArr = [...atArr1, ...atArr2, ...atArr3]
    },
    chooseAccount(i, index) {
      this.accountsIndex.splice(i, 1, index)
      if (this.hiddenElement) this.hiddenElementFun(true)
    },
    // 获取交易商详情内容
    async getdealerInfo(traderCodes) {
      console.log('traderCodes::: ', traderCodes)
      if (traderCodes.length === 0) return
      // 判断是否为更新中
      const updatingRes = await this.$api.common
        .CV3(
          {
            traderCode: traderCodes[0]
          },
          { Routes: ' wikifxagg$trader_updating_toast' }
        )
        .catch(() => {
          console.log('wikifxagg$trader_updating_toast------error')
        })
      const toastData = updatingRes?.wikifxagg?.trader_updating_toast?.data
      console.log('toastData::: ', toastData)
      console.log(this.autocompleteValue, 'autocompleteValue')
      if (toastData) this.autocompleteValue = ['', '', '', '', '']
      if (toastData)
        return this.$message({
          message: toastData,
          type: 'warning',
          customClass: 'vs-toast'
        })

      this.loading = true
      const elUrlNameList = []
      await this.$api.compare
        .clientGetUrlName({ codes: traderCodes.toString() })
        .then((res) => {
          console.log('res::: ', res)
          if (res?.length) {
            res &&
              res.forEach((el) => {
                elUrlNameList.push({
                  TraderCode: el.TraderCode,
                  urlName: el.Name
                })
              })
          } else {
            this.loading = false
            return false
          }
        })
        .catch(() => {
          console.log('客户端获取urlName错误')
          this.autocompleteValue.splice(this.tabIndex, 1, '')
          this.$message.error('Error')
          this.loading = false
        })

      if (elUrlNameList.length == 0) return
      // else this.loading = false

      const res = await this.$api.compare
        .compare({
          traderCodes,
          ip: this.$store.state.userIp,
          period: 2,
          isWeb: 1,
          platformType: 2,
          index: 1,
          size: 20
        })
        .catch(() => {
          console.log('compare,客户端交易商对比接口错误')
          this.loading = false
        })
      if (!res) {
        return
      }
      this.addUrlName(elUrlNameList[0].urlName, elUrlNameList[0].TraderCode)
      this.autocompleteValue.splice(this.tabIndex, 1, '')
      const traderInfo = res.TraderInfoResponse || []
      const infoData = res.TradeBrokersContrastResponse || []
      // 实勘好评
      const traderCount = res.TraderCountResponse?.items || []
      const exposedTraderList = res.ExposedTraderList || []
      const MultipleTrader = res.MultipleTrader || []
      const TraderArticles = res.TraderArticles || []
      const TraderIntros = res.TraderIntros || []
      const exposedTotal = []
      exposedTraderList.forEach((el) => {
        // console.log(el, 'el456')
        exposedTotal.push({ exposedTotal: el.count })
      })
      const list = traderInfo.map((item, index) => {
        return {
          ...elUrlNameList[index],
          ...infoData[index],
          ...MultipleTrader[index],
          ...TraderArticles[index],
          ...TraderIntros[index],
          ...traderCount[index],
          ...exposedTotal[index],
          ...item
        }
      })
      // this.list.splice(this.tabIndex, 1, list[0])
      let AdIndex = 0
      let AdinList = false
      list.forEach((el, i) => {
        const emptyLlist = []
        el.accounts &&
          el.accounts.forEach((val) => {
            emptyLlist.push(val.accountName)
          })
        const licensesList = []
        el.basic?.licenses?.forEach((item) => {
          licensesList.push(item.shortName)
        })
        const first = this.list[0]?.score
        const second = this.list[1]?.score
        // const third = this.list[2] && this.list[2].score
        if (!second) {
          this.tabIndex = 1
        }
        if (!first) {
          this.tabIndex = 0
        }

        this.list.forEach((el, index) => {
          if (el.AdSlogan) {
            AdIndex = index
            AdinList = true
          }
        })

        // this.dealerNameList.push(this.getshortName(el.shortName, el.localshortname))
        this.dealerNameList.splice(AdinList ? AdIndex : this.tabIndex, AdinList ? 0 : 1, this.getOnlyShortName(el.shortName, el.localshortname)).slice(0, 3)
        this.list.splice(AdinList ? AdIndex : this.tabIndex, AdinList ? 0 : 1, {
          hitsInfo: el.hitsInfo,
          shortName: el.shortName,
          localshortname: el.localshortname,
          icon: el.icon,
          urlName: el.urlName,
          content: el.content,
          summary: el.summary,
          TraderArticles: el.TraderArticles || null,
          MultipleTrader: el.MultipleTraderExposure || null,
          exposedTotal: el.exposedTotal || 0,
          surveyList: el.list || [],
          code: el.code || el.TraderCode,
          logo: el.logo,
          // 天眼评分
          score: ((el.rating && el.rating.score) * 1).toFixed(2) || '--',
          status: el.rating.status || '--',
          isEPC: el?.rating.isEPC == 'true' ? '保障中' : '无保障',
          risk: el.rating.risk || 0,
          webSite: el.rating.webSite || '--', // 网址
          // 基本信息
          established: el.basic.established || '--',
          licensesItems: licensesList.toString() || '--',
          existmt4: el.basic.existmt4.toString() == 'true' ? 1 : 0,
          existmt5: el.basic.existmt5.toString() == 'true' ? 1 : 0,
          existcurrency: el.basic.existcurrency.toString() == 'true' ? 1 : 0,
          methods: el.basic.methods || '--',
          // 交易环境
          Grade: el.Grade || '--',
          SpeedGrade: el.SpeedGrade || '--',
          AveSpeed: el.AveSpeed || '--',
          FastestSpeed: el.FastestSpeed || '--',
          FastestSpeed_Open: el.FastestSpeed_Open || '--',
          FastestSpeed_Close: el.FastestSpeed_Close || '--',
          SlowestSpeed: el.SlowestSpeed || '--',
          SlowestSpeed_Open: el.SlowestSpeed_Open || '--',
          SlowestSpeed_Close: el.SlowestSpeed_Close || '--',
          // 交易滑点
          SlipGrade: el.SlipGrade || '--',
          AveSlip_wh: el.AveSlip_wh || '--',
          AveSlip_xau: el.AveSlip_xau || '--',
          MaxSlip: el.MaxSlip || '--',
          MaxSlip_Positive: el.MaxSlip_Positive || '--',
          MaxSlip_Negative: el.MaxSlip_Negative || '--',
          // 交易成本
          CostGrade: el.CostGrade || '--',
          AveCost_wh: el.AveCost_wh || '--',
          AveCost_xau: el.AveCost_xau || '--',
          // 隔夜成本
          SwapGrade: el.SwapGrade || '--',
          AveLongSwap_wh: el.AveLongSwap_wh || '--',
          AveShortSwap_wh: el.AveShortSwap_wh || '--',
          AveLongSwap_xau: el.AveLongSwap_xau || '--',
          AveShortSwap_xau: el.AveShortSwap_xau || '--',
          // 断线情况
          OffLineGrade: el.OffLineGrade || '--',
          AveReconnectNum: el.AveReconnectNum || '--',
          AveReconnectTime: el.AveReconnectTime || '--',
          // 账户信息
          accountName: (el.accounts && el.accounts[0] && el.accounts[0].accountName) || '--',
          allAccounts: el.accounts || [
            {
              accountName: '--',
              transactionType: '--',
              enterCondition: '--',
              maxLever: '--',
              mainSpread: '--',
              outStockRatio: '--',
              spreadType: '--',
              minCash: '--',
              allowLock: '--',
              allowScalping: '--',
              allowEA: '--',
              cryptocurrency: '--'
            }
          ], // 数组 所有账户
          allName: emptyLlist.toString() || '--'
          // allAccountsType: el.accounts.forEach((el) => { return allAccountsType.push(el.accountName) }) || '--'
        })
      })
      // console.log(this.list, 'list')
      if (this.list.length > 3) this.list.slice(0, 3)
      this.loading = false
      if (this.hiddenElement) this.hiddenElementFun(true)
      this.getAtArr()
    },

    onScrolls() {
      if (this.isMobile) return
      // const a = document.getElementById('first-floor').getBoundingClientRect().top
      const b = document.getElementById('second-floor').getBoundingClientRect().top
      const c = document.getElementById('third-floor').getBoundingClientRect().top
      // console.log('c::: ', c)
      const d = document.getElementById('fourth-floor').getBoundingClientRect().top
      // console.log('d::: ', d)
      const e = document.getElementById('five-floor')?.getBoundingClientRect().top
      // console.log('e::: ', e)
      const f = document.getElementById('six-floor')?.getBoundingClientRect().top
      // console.log('f::: ', f)
      if (b > 320) {
        this.isActived = 0
      } else if (b <= 320 && c > 320) {
        this.isActived = 1
      } else if (c <= 320 && d > 320) {
        this.isActived = 2
      } else if (d <= 320 && e > 162) {
        this.isActived = 3
      } else if (e <= 162 && f > 162 && this.setTabList.length > 5) {
        this.isActived = 4
      } else {
        if (this.setTabList.length == 4) this.isActived = 3
        if (this.setTabList.length == 5) this.isActived = 4
        else this.isActived = 5
      }
    },
    // 切换TabList
    chooseTab(index, selector) {
      if (this.isLongLanguage) {
        const tabsBox = document.getElementById('tabs-box')
        if (index > 3) {
          tabsBox.scrollTo(0, 100)
        } else {
          tabsBox.scrollTo(0, 0)
        }
      }
      // console.log(index)
      this.isActived = index
      if (index == 0) {
        selector = '#first-floor'
      } else if (index == 1) {
        selector = '#second-floor'
      } else if (index == 2) {
        selector = '#third-floor'
      } else if (index == 3) {
        selector = '#fourth-floor'
      } else if (index == 4) {
        selector = '#five-floor'
      } else if (index == 5) {
        selector = '#six-floor'
      }
      this.selector = selector
      const anchor = this.$el.querySelector(selector)
      anchor.scrollIntoView({
        behavior: 'smooth', // 平滑过渡
        block: 'start', // 上边框与视窗顶部平齐
        inline: 'center'
      })
      if (index == 0) {
        window.scrollTo(0, 0)
      }
      this.isShowMobileTabList = false
    },
    // 搜索 async
    async querySearch(queryString, cb) {
      // console.log(this.rankList, '排行榜数据')
      let restaurants = []
      if (queryString) {
        // 智能搜索
        this.$api.compare
          .compareSearch({
            content: queryString,
            project: 1,
            type: 1,
            product: 2,
            isInternational: false,
            isMinal: false,
            isApp: false
          })
          .then((res) => {
            restaurants = []
            res.items &&
              res.items.forEach((el) => {
                if (!this.urlCodeList.toString().includes(el.code)) {
                  restaurants.push({
                    value: el.shortName || el.englishShortName,
                    ico: el.ico,
                    code: el.code,
                    urlName: el.urlName,
                    logo: el.logo
                  })
                }
              })
            cb(restaurants)
          })
          .catch(() => {
            console.log('智能搜索错误')
          })
      } else {
        restaurants = []
        await this.rankList.forEach((el) => {
          if (!this.urlCodeList.toString().includes(el.code)) {
            restaurants.push(el)
          }
        })
        cb(restaurants)
      }
    },
    handleSelect(item) {
      const code = item.code.split()
      this.getdealerInfo(code)
      // this.getUrlName(item.code) // 添加urlName
    },
    // 在url 上添加交易商urlName
    addUrlName(name, code, isFirst = false) {
      const num = this.urlNameList.length
      if (!isFirst) {
        let AdIndex = 0
        let AdinList = false
        this.list.forEach((el, index) => {
          if (el.AdSlogan) {
            AdIndex = index
            AdinList = true
          }
        })

        this.urlNameList.splice(AdinList ? AdIndex : this.tabIndex, AdinList ? 0 : 1, name).slice(0, 3)
        this.urlCodeList.splice(AdinList ? AdIndex : this.tabIndex, AdinList ? 0 : 1, code).slice(0, 3)
        // this.urlNameList.push(name)
        // this.urlCodeList.push(code)
      }

      const params = this.urlNameList.join('-vs-')
      let newUrl = `/${this.$store.state.LanguageCode}/compare`
      if (num > 0) newUrl = `/${this.$store.state.LanguageCode}/compare/` + params
      // history.replaceState(null, null, newUrl)
      // history.pushState(0, '0', newUrl)
      window.history.pushState({ path: newUrl }, '', newUrl)
      this.$store.commit('setPath', 'compare/' + params || '')
    },
    pinnedLeft(val, i) {
      // 钉住在左侧
      const dom = document.getElementById('dealerIndex0')
      if (this.isPinnedLeft && i == 0) {
        this.isPinnedLeft = !this.isPinnedLeft
        dom.style = 'position:relative !important; left:unset; z-index: unset;'
      } else {
        this.pinnedLeftIndex = i
        this.isPinnedLeftCode = val.code
        this.isPinnedLeft = true

        this.list.splice(i, 1)
        this.list.unshift(val)

        const dealerName = this.dealerNameList[i]
        this.dealerNameList.splice(i, 1)
        this.dealerNameList.unshift(dealerName)

        const name = this.urlNameList[i]
        this.urlNameList.splice(i, 1)
        this.urlNameList.unshift(name)

        const code = this.urlCodeList[i]
        this.urlCodeList.splice(i, 1)
        this.urlCodeList.unshift(code)

        // console.log(dom)
        if (this.LanguageCode == 'ar') {
          if (this.isMobile) {
            dom.style = 'position:sticky !important; right:0;  z-index: 39;'
          } else {
            dom.style = 'position:sticky !important; right:360px; z-index: 39;'
          }
        } else {
          dom.style = 'position:sticky !important; left:0px; z-index: 39;'
        }
      }
    },
    // 关闭
    close(index, item) {
      if (!item.code) return
      if (this.urlNameList.length && this.list.length > 3) {
        this.list.splice(index, 1)
      } else {
        this.list.splice(index, 1)
        this.list.push({})
      }
      const arr = []
      this.atArr.forEach((el) => {
        if (el.urlName != item.urlName) {
          arr.push(el)
        }
      })
      this.atArr = arr
      this.delUrlName(item.urlName, item.code, this.getOnlyShortName(item.shortName, item.localshortname)) // 获取urlName,并且删除urlName
      if (this.hiddenElement) this.hiddenElementFun(true)
    },
    // 删除urlName
    delUrlName(name, code, dealerName) {
      if (name)
        this.urlNameList.splice(
          this.urlNameList.findIndex((item) => item === name),
          1
        )
      if (code)
        this.urlCodeList.splice(
          this.urlCodeList.findIndex((item) => item === code),
          1
        )
      if (dealerName)
        this.dealerNameList.splice(
          this.dealerNameList.findIndex((item) => item === dealerName),
          1
        )
      const params = this.urlNameList.join('-vs-')
      let newUrl = `/${this.$store.state.LanguageCode}/compare/`
      if (this.urlNameList.length > 0) newUrl = `/${this.$store.state.LanguageCode}/compare/${params}`
      window.history.pushState({ path: newUrl }, '', newUrl)
      this.$store.commit('setPath', 'compare/' + params || '')
    },
    // 选择交易商的索引
    inputIndex(index) {
      if (!index) {
        return
      }
      this.tabIndex = index
      this.isShowMobileTabList = false
    },
    getRankList() {
      // 获取排行榜前20
      this.$api.home
        .invokev3(
          {
            languageCode: this.$store.state.LanguageCode,
            countryCode: this.$store.state.CountryCode
          },
          {
            Routes: 'wikifx$traderexpandlist'
          }
        )
        .catch(() => {
          console.log('compare[getRankList],交易商对比rank接口错误')
        })
        .then((res) => {
          const expandlist = res && res.wikifx && res.wikifx.traderexpandlist && res.wikifx.traderexpandlist.data && res.wikifx.traderexpandlist.data.length > 0
          // console.log(expandlist, '排行榜')
          if (expandlist && expandlist.length > 0) {
            expandlist.forEach((el) => {
              if (!this.urlCodeList.includes(el.traderCode)) {
                this.rankList.push({
                  value: el.shortName,
                  code: el.traderCode || el.code,
                  ico: el.ico,
                  logo: el.logo,
                  name: el.localShortName
                })
              }
            })
          }
        })
    },
    // 获取实勘内容
    getSurvey(code, num) {
      const lang = this.$store.state.LanguageCode
      let text = '--'
      if (code == '8001') {
        text = lang == 'zh-cn' ? '精品' : lang == 'zh' ? '精品' : 'Perfect'
      } else if (code == '8002') {
        text = lang == 'zh-cn' ? '好评' : lang == 'zh' ? '好評' : 'Great'
      } else if (code == '8003') {
        text = lang == 'zh-cn' ? '良好' : lang == 'zh' ? '良好' : 'Good'
      } else if (code == '8004') {
        text = lang == 'zh-cn' ? '差评' : lang == 'zh' ? '差评' : 'Danger'
      } else if (code == '8005') {
        text = lang == 'zh-cn' ? 'VR' : lang == 'zh' ? 'VR' : 'VR'
      } else if (code == '8006') {
        text = lang == 'zh-cn' ? '一般' : lang == 'zh' ? '一般' : 'Average'
      } else {
        text = '--'
      }
      const unit = lang == 'zh-cn' ? '条' : lang == 'zh' ? '條' : ''
      const txt = lang == 'zh-cn' || lang == 'zh' ? text + ' ' + num + ' ' + unit : num + ' ' + text
      return txt
    },
    getRisk(num) {
      // 风险测评和天眼曝光
      if (num) {
        return this.$v('{0}条').replace(/\{0\}/g, num)
      } else {
        return ''
      }
    },
    // 处理链接点击事件，针对“公司网址”这一项调用接口判断是否直接跳转
    handleLink(e = {}, obj = {}) {
      const { code, webSite } = obj || {}
      e?.preventDefault()
      const { allHost, user, LanguageCode: locale, CountryCode: nationCode, userIp } = this.$store.state
      this.$api.common
        .CV3(
          {
            type: 1, // 1交易商，3代理商，5自营交易商
            code,
            spots: 1,
            url: webSite,
            platform: 3,
            apptype: 0,
            equipId: this.$Cookie.get('wiki-bfp'),
            jumpStatisticsUrl: allHost,
            lang: locale,
            country: nationCode,
            userid: user.userId || '0',
            ip: userIp
          },
          { Routes: 'statistics$tradercountv3' }
        )
        .then((res) => {
          const { isShowNotFound, type: category, url: apiLink } = res?.statistics?.tradercountv3?.data || {}
          this.companyWebsite = webSite
          this.returnWebsite = apiLink
          if (isShowNotFound) {
            const hintDom = this.$refs?.noteDom
            hintDom?.unableAccess(true)
            hintDom?.open()
          } else if (this.tips?.title) {
            this.moduleShow = true
            this.tipsType = String(category)
            const delayTimer = setTimeout(() => {
              clearTimeout(delayTimer)
              this.$refs?.riskDom?.open()
            }, 0)
          } else this.nextToDo(category)
        })
        .catch(() => {})
    },
    // 关闭“特别提示”弹框
    closeRiskDialog() {
      this.moduleShow = false
      this.modelShow = false
    },
    // 关闭弹框后需要的操作
    nextToDo(val = 0) {
      if (val == '0') {
        this.modelShow = true
        this.$refs?.noteDom?.open()
      } else if (val == '1') {
        const returnUrl = this.returnWebsite
        const { mobile, LanguageCode: locale } = this.$store.state
        if (!returnUrl?.includes('mobile/tradertips')) {
          const delayTimer = setTimeout(
            () => {
              clearTimeout(delayTimer)
              createJump(returnUrl)
            },
            mobile ? 400 : 0
          )
          this.closeRiskDialog()
        } else if (returnUrl?.includes('flgship=1')) {
          const delayTimer = setTimeout(
            () => {
              clearTimeout(delayTimer)
              createJump(`/${locale}/warning.html?url=${this.companyWebsite}`)
            },
            mobile ? 400 : 0
          )
        } else if (returnUrl?.includes('flgship=0')) {
          this.modelShow = true
          this.$refs?.noteDom?.open()
        }
      }
      // 创建跳转链接
      function createJump(url = '') {
        const a = document.createElement('a')
        a.setAttribute('href', url)
        a.setAttribute('target', '_blank')
        a.setAttribute('id', 'startTelMedicine')
        if (document.getElementById('startTelMedicine')) {
          document.body.removeChild(document.getElementById('startTelMedicine')) // 防止反复添加
        }
        document.body.appendChild(a)
        a.click()
      }
    }
  }
}
